import React from 'react';
import { competencies } from '../../data/capabilities';
import { SectionHeading } from '../SectionHeading';
export function Skills() {
  return <section id="skills" className="w-full bg-white py-20 lg:py-28" data-id="element-139" data-mp="wqxwnhsk4edh">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-140" data-mp="i1rx1spt4m52">
        <SectionHeading title="Skills" intro="Core functional competencies applied at enterprise scale." data-id="element-141" data-mp="mztigkapgxjp" />

        <dl className="mt-14 grid grid-cols-1 gap-x-16 sm:grid-cols-2" data-id="element-142" data-mp="1aqfo64x8m5qj">
          {competencies.map(competency => <div key={competency.title} className="border-t border-navy-900/15 py-7" data-id="element-143" data-mp="1fnz2t5xukkj0">
              <dt className="font-display text-lg font-semibold text-navy-900" data-id="element-144" data-mp="11r2bl3dth11l">
                {competency.title}
              </dt>
              <dd className="mt-2.5 text-[15px] leading-relaxed text-muted" data-id="element-145" data-mp="3mef8v4cocehr">
                {competency.detail}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}